export function getRolesForPath(path, sidebarMenu) {
  // Fungsi rekursif untuk mencari path di menu dan children
  const findMenu = (menus, targetPath) => {
    for (const menu of menus) {
      // Exact match untuk path utama
      if (menu.path === targetPath) {
        return menu.roles || null;
      }

      // Cek di children jika ada
      if (menu.children) {
        for (const child of menu.children) {
          // Exact match untuk child path
          if (child.path === targetPath) {
            return child.roles || menu.roles || null;
          }

          // Partial match untuk nested routes
          if (targetPath.startsWith(child.path)) {
            return child.roles || menu.roles || null;
          }
        }
      }
    }
    return null;
  };

  return findMenu(sidebarMenu, path);
}
